import React, { memo } from 'react';

const FooterWarehouseImport = () => {
    return (
        <a
            href='https://docs.vmass.vn/quan-ly/warehouse-transfer'
            target='_blank'
            className='mb-0 pl-2'
        >
            Hướng dẫn
        </a>
    );
};

export default memo(FooterWarehouseImport);
